<template>
  <v-sheet class="create-card-sheet">
    <dialog-loading v-if="saving" loadingText="Salvando..."></dialog-loading>
    <dialog-loading v-if="loading" loadingText="Carregando..."></dialog-loading>

    <div :class="['create-card__toolbar-slot d-flex justify-center mx-1', no_margin ? '' : 'mt-2']">
      <slot name="header"></slot>
    </div>

    <v-row class="create-card__page justify-center">
      <v-col cols="12" md="10" lg="8" xl="7" class="pa-0">
        <v-card
          width="100%"
          height="100%"
          :flat="flat"
          :class="['create-card', flat ? 'create-card--flat' : '', no_margin ? '' : 'mt-5']"
        >
          <!-- Título totalmente customizado -->
          <template v-if="$slots.card_title">
            <div class="create-card__hero">
              <slot name="card_title"></slot>
            </div>
            <v-divider class="create-card__rule ma-0" />
          </template>

          <template v-else>
            <header class="create-card__hero">
              <div
                v-if="!$slots.title"
                class="create-card__head-grid"
                :class="{ 'create-card__head-grid--back': route_back }"
              >
                <div v-if="route_back" class="create-card__back-cell">
                  <f-btn
                    edit
                    alt_text="Voltar"
                    alt_icon="mdi-arrow-left-bold"
                    class="create-card__back-btn"
                    @click="$router.push({ name: route_back, params: return_params ? { ...$route.params } : {} })"
                  />
                </div>
                <p class="create-card__eyebrow create-card__cell-eyebrow">Novo cadastro</p>
                <h2 class="create-card__title create-card__cell-title">Cadastrar {{ model_name }}</h2>
                <p class="create-card__hint create-card__cell-hint">Preencha os dados abaixo para salvar.</p>
              </div>
              <div v-else class="create-card__hero-custom d-flex align-center">
                <div v-if="route_back" class="create-card__back mr-3 mr-md-4 flex-shrink-0">
                  <f-btn
                    edit
                    alt_text="Voltar"
                    alt_icon="mdi-arrow-left-bold"
                    class="create-card__back-btn"
                    @click="$router.push({ name: route_back, params: return_params ? { ...$route.params } : {} })"
                  />
                </div>
                <div class="create-card__intro flex-grow-1">
                  <slot name="title"></slot>
                </div>
              </div>
            </header>
            <v-divider class="create-card__rule ma-0" />
          </template>

          <v-card-text class="create-card__form pa-0">
            <div class="create-card__form-body">
              <slot name="form"></slot>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: 'CreateCard',
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    route_back: {
      type: String,
      default: null,
    },
    model_name: {
      type: String,
      default: 'Item',
    },
    no_margin: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    return_params: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* Fundo único em toda a área da tela (evita faixa da cor do v-main / body) */
.create-card-sheet {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f5f5f5;
}

.create-card {
  border-radius: 12px;
  overflow: hidden;
  background: #fff !important;
  border: 1px solid #e2e8f0;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 8px 24px rgba(15, 23, 42, 0.06);
}

.create-card--flat {
  box-shadow: none !important;
  border: none !important;
  background: transparent !important;
}

.create-card__hero {
  padding: 22px 20px 20px;
}

@media (min-width: 600px) {
  .create-card__hero {
    padding: 28px 28px 24px;
  }
}

.create-card__back-btn {
  border-radius: 10px !important;
}

.create-card__intro {
  flex: 1 1 auto;
  min-width: 0;
}

/* Cabeçalho padrão: eyebrow em cima; voltar alinhado ao centro vertical da linha do título */
.create-card__head-grid {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 14px;
  row-gap: 0;
}

.create-card__head-grid--back {
  grid-template-columns: auto 1fr;
}

.create-card__head-grid--back .create-card__cell-eyebrow {
  grid-column: 2;
  grid-row: 1;
}

.create-card__head-grid--back .create-card__back-cell {
  grid-column: 1;
  grid-row: 2;
  align-self: center;
}

.create-card__head-grid--back .create-card__cell-title {
  grid-column: 2;
  grid-row: 2;
}

.create-card__head-grid--back .create-card__cell-hint {
  grid-column: 2;
  grid-row: 3;
}

.create-card__head-grid:not(.create-card__head-grid--back) .create-card__cell-eyebrow,
.create-card__head-grid:not(.create-card__head-grid--back) .create-card__cell-title,
.create-card__head-grid:not(.create-card__head-grid--back) .create-card__cell-hint {
  grid-column: 1;
}

.create-card__hero-custom {
  gap: 0;
}

.create-card__eyebrow {
  margin: 0 0 6px;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748b;
}

.create-card__title {
  margin: 0 0 8px;
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: #0f172a;
}

@media (min-width: 600px) {
  .create-card__title {
    font-size: 1.5rem;
  }
}

.create-card__hint {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.45;
  color: #64748b;
  max-width: 42rem;
}

.create-card__rule {
  border-color: #e2e8f0 !important;
}

/* Corpo do formulário — “área de trabalho” */
.create-card__form-body {
  padding: 20px 18px 32px;
  background: #f8fafc;
  min-height: 120px;
}

@media (min-width: 600px) {
  .create-card__form-body {
    padding: 28px 28px 40px;
  }
}
</style>
